import { styled } from "styled-components";
import { Link } from "react-router-dom"

export const CustomLinkStyle = styled(Link)<{ width?: string }>`
    width: ${({ width }) => width || "100%"};
    height: auto;
    text-decoration: none;
    color: #fff;    
    display: flex;
    justify-content: center;
    align-items: center;    
`